import { createSelector } from 'reselect';

import { AppState } from '../rootReducer';

const getLoading = (state: AppState) => state.division.loading;
const getDivisionList = (state: AppState) => state.division.divisionList;
const getDivisionCount = (state: AppState) => state.division.total;
const getError = (state: AppState) => state.division.error;

export const divisionLoadingSelector = createSelector(getLoading, (loading) => loading);

export const getDivisionListSelector = createSelector(getDivisionList, (divisionList) => divisionList);

export const divisionCountSelector = createSelector(getDivisionCount, (total) => total);

export const divisionErrorSelector = createSelector(getError, (error) => error);
